export const types = {
  setLoadingStatus: "[loadingAction] setLoadingStatus",
  setCalculing: "[loadingAction] setCalculing",
  setLoginErr: "[authErrAcion] setLoginErr",
  storeUserData: "[loginAcion] storeUserData",
  setLogged: "[loginAcion] setLogged",

  //// notificaciones
  notification: "[notificacionAction] notification",
  storeVersionBackend: "[notificacionAction] storeVersionBackend",

  //// asistencias
  storeAsistenciasPorConfirmar:
    "[asistenciasAction] storeAsistenciasPorConfirmar",
  storeAsistenciasVivas: "[asistenciasAction] storeAsistenciasVivas",
  setOpenLateral: "[asistenciasAction] setOpenLateral",
  storeAsistencia: "[asistenciasAction] storeAsistencia",
  storeArchivos: "[asistenciasAction] storeArchivos",
  setCargandoAsistencia: "[asistenciasAction] setCargandoAsistencia",
  setLoadingConfirmarProveedor: "[asistenciasAction] setLoadingConfirmarProveedor",

  //// Otros
  storeProveedorInfo: "[asistenciasAction] storeProveedorInfo",
  setConfirmaAsistenciaData: "[asistenciasAction] setConfirmaAsistenciaData",

  handleModalVersion: "[facturacionAction] handleModalVersion",

  // facturacion servicios
  storeServiciosPorValidar: "[facturacionReducer] storeServiciosPorValidar",
  storeServiciosPorGenerarOp: "[facturacionReducer] storeServiciosPorGenerarOp",
  storeServiciosRechazados: "[facturacionReducer] storeServiciosRechazados",
  storeOrdenesAbiertas: "[facturacionReducer] storeOrdenesAbiertas",
  setLoadingCrearOP: "[facturacionReducer] setLoadingCrearOP",
  
  //
  storeQR: "[asistenciasAction] storeQR",
  showModal: "[facturacionAction] showModal",
  storeOrdenPagoFull: "[facturacionAction] storeOrdenPagoFull",
  setLoadingOp: "[facturacionAction] setLoadingOp",

  // Solicitudes de atención a proveedores
  storeSolicitudes: "[solicitudesAction] storeSolicitudes",
  storeHistorialSolicitud: "[solicitudesAction] storeHistorialSolicitud", 
  setLoadingSolicitudes: "[solicitudesAction] setLoadingSolicitudes",
  setCreandoSolicitud: "[solicitudesAction] setCreandoSolicitud",
  addMensajeSolicitud: "[solicitudesAction] addMensajeSolicitud",
  setSolicitudActiva: "[solicitudesAction] setSolicitudActiva",
  setMensajesNoLeidos: "[solicitudesAction] setMensajesNoLeidos",
  updateEstadoSolicitud: "[solicitudesAction] updateEstadoSolicitud",
  
  // Updates optimistas
  addSolicitudOptimista: "[solicitudesAction] addSolicitudOptimista",
  removeSolicitudOptimista: "[solicitudesAction] removeSolicitudOptimista",
  addMensajeOptimista: "[solicitudesAction] addMensajeOptimista",
  removeMensajeOptimista: "[solicitudesAction] removeMensajeOptimista",
  updateSolicitudEstatus: "[solicitudesAction] updateSolicitudEstatus",
  storeUltimoMensaje: "[solicitudesAction] storeUltimoMensaje",
  
  // Archivos de solicitudes
  storeArchivosSolicitud: "[solicitudesAction] storeArchivosSolicitud",
  setLoadingArchivos: "[solicitudesAction] setLoadingArchivos",
  setSubiendoArchivo: "[solicitudesAction] setSubiendoArchivo",
  addArchivoOptimista: "[solicitudesAction] addArchivoOptimista",
  removeArchivoOptimista: "[solicitudesAction] removeArchivoOptimista",

};
